import React from 'react';

import Header from '../../layout/Header.jsx';
import ListAnswers from '../../lists/ListAnswers.jsx';

const PageAnswers = () => (
  <div>
    <Header>Scores</Header>
    <ListAnswers />
  </div>
);

export default PageAnswers;
